<template>
  <v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <h4>Välj yrke</h4>
      </v-card>
    </v-card>

    <v-row no-gutters class="mt-4">
      <v-col cols="12" md="6">
        <v-card-text>
          <v-select v-model="professionSelect" :items="professions" label="Välj yrke" persistent-hint return-object
            single-line outlined @change="changeProfession()" class="professions mx-auto"></v-select>
        </v-card-text>
      </v-col>
    </v-row>

    <template v-if="get(professionSelect, 'value', null)">
      <v-row no-gutters>
        <v-col cols="12" md="6">
          <v-card-text>
            <ProfessionReformSelector @on-change="changeReform($event)" />
          </v-card-text>
        </v-col>
      </v-row>

      <v-card-text>
        <v-expansion-panels :multiple="true">
          <v-expansion-panel
            v-for="(group, index) in sortBy(Object.keys(courses), [v => { const order = { G: 1, P: 2, I: 3, F: 4 }; return order[v.charAt(0)] }])"
            :key="index">
            <v-expansion-panel-header class="subtitle-1">
              <b>{{ group }}</b>
            </v-expansion-panel-header>

            <v-expansion-panel-content v-for="(child, idx) in sortBy(courses[group], ['courseCode'])" :key="idx">
              <v-row no-gutters>
                <v-col>
                  <span class="body-1">{{ child.courseName }}</span>
                  <p class="caption">{{ child.credit | filterCredit }} {{ child.courseCode }} {{ child.alias ? `(${child.alias})` : '' }}</p>
                </v-col>
                <v-col class="d-flex align-center justify-end">
                  <v-btn color="secondary" class="icon mr-2" @click="deleteItem(group, child.id)">
                    <v-icon>$sl-delete</v-icon>Radera
                  </v-btn>

                  <v-btn @click="editCourse(child)">
                    <v-icon class="mr-2">$sl-edit</v-icon>
                    Redigera
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="6">
                  <v-select outlined v-model="courseGroups[group]" :disabled="!availableCourses[group].length"
                    :items="availableCourses[group].map(o => ({ value: o.id, text: o.courseName, code: o.courseCode, credit: o.credit }))"
                    return-object single-line></v-select>
                </v-col>

                <v-col cols="6">
                  <v-card-actions class="pl-0 mt-2">
                    <v-btn @click="addItem(group)" :disabled="!availableCourses[group].length || !courseGroups[group]">
                      <v-icon class="mr-2">$sl-add</v-icon>Lägg till
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </template>

    <TheEditCourseDialog :is-visible="editDialogIsVisible" :course="course" @close="editDialogIsVisible = false"
      @on-save="updateCourse($event)" />
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import sortBy from "lodash/sortBy"
import findIndex from "lodash/findIndex"
import { get } from 'lodash'
import TheEditCourseDialog from '@/components/dialog/TheEditCourseDialog.vue'
import ProfessionReformSelector from '@/components/admin/profession/ProfessionReformSelector.vue'
// @group Common
// ProfessionCourses component
export default {
  name: 'ProfessionCourses',

  components: {
    TheEditCourseDialog,
    ProfessionReformSelector
  },

  data: () => ({
    courseGroups: {},
    professions: [],
    courses: {},
    allCourses: [],
    professionSelect: '',
    editDialogIsVisible: false,
    course: null,
    selectedReform: {
      value: 1, text: 'Gy11'
    }
  }),

  filters: {
    filterCredit(c) {
      if (c && Number(c) >= 0) return c + " poäng";
      else return "";
    }
  },

  created() {
    this.fetchProfessions()
    this.fetchCourses()
  },

  computed: {
    // @vuese
    //- Grab allCourses and reduce by already choosen
    availableCourses() {
      const c = {}
      for (const i of this.allCourses) {
        if (!c[i.groupName]) {
          c[i.groupName] = []
        }
        c[i.groupName].push(i)
      }
      let idx
      for (const i of Object.keys(this.courses)) {
        for (const j of this.courses[i]) {
          idx = findIndex(c[i], ['id', j.id])
          c[i].splice(idx, 1)
        }
      }
      return c
    }
  },

  methods: {

    get,

    // @vuese
    //- Find item in array
    addItem(grp) {
      const idx = findIndex(this.allCourses, ['id', this.courseGroups[grp].value])
      if (idx == -1) return

      // @vuese
      //- Add to db and splice
      API.createProfessionCourses({
        data: {
          professionId: this.professionSelect.value,
          courseId: this.courseGroups[grp].value
        }
      })
        .then(() => {
          this.courses[grp].splice(this.courses[grp].length, 1, this.allCourses[idx])
          this.courseGroups[grp] = null
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    // @vuese
    //- Find item in array
    async deleteItem(grp, id) {
      const idx = findIndex(this.courses[grp], ['id', id])
      if (idx > -1) {
        const res = await this.$dialog.confirm({
          title: 'Radera kurs',
          text: `Är du säker på att du vill ta bort kursen ${this.courses[grp][idx].courseName}?`,
          actions: [
            {text: 'Avbryt', key: false, icon: '$sl-cancel'},
            {
              text: 'Radera',
              key: true,
              icon: '$sl-delete',
              outlined: true
            }
          ]
        })

        if ( res !== true ) return

        // @vuese
        //- Remove from db and splice
        API.deleteProfessionCourses({ data: { professionId: this.professionSelect.value, courseId: id } })
          .then(response => {
            this.courses[grp].splice(idx, 1)
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      }
    },
    // @vuese
    //- Used to list profession courses
    changeProfession() {
      if (this.professionSelect && this.professionSelect.value) {
        API.listProfessionCourses(this.professionSelect.value, { data: { reform: get(this, 'selectedReform.text', null) } })
          .then(response => {
            this.courses = response.data
            this.courseGroups = Object.fromEntries(Object.keys(response.data).map(f => { return [f, null] }))
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      }
    },
    // @vuese
    //- Stunt to make imported funktion a this.func to be used in template 
    sortBy: sortBy,

    fetchProfessions() {
      API.listProfessions()
        .then(response => {
          this.professions = response.data.map(o => ({
            value: o.id,
            text: o.name
          }))
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    // @vuese
    //- Used to list courses
    fetchCourses() {
      API.listCourses({ data: { reform: get(this, 'selectedReform.text', null) } })
        .then(response => {
          this.allCourses = response.data
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    editCourse(course) {
      this.editDialogIsVisible = true
      this.course = course
    },

    updateCourse(course) {
      const idx = findIndex(this.courses[course.groupName], ['id', course.id])
      if (idx === -1) return
      this.courses[course.groupName].splice(idx, 1, course);
    },

    async changeReform(reform) {
      try {
        this.selectedReform = reform
        await Promise.all([
          this.changeProfession(),
          this.fetchCourses()
        ])
      } catch (error) {
        console.log('There was an error:', error)
        this.$events.fire('showError', `Det har uppstått ett problem :: ${error}`)
      }
    }
  }
}
</script>

<style scoped></style>
